var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index main"},[_c('div',{staticClass:"head"}),_c('div',{staticClass:"title"}),_c('div',{staticClass:"ornament-1"}),_c('div',{staticClass:"ornament-2"}),_c('div',{staticClass:"ornament-3"}),_c('div',{staticClass:"logo"})])
}]

export { render, staticRenderFns }